import { makeConnectedNavbar } from "features/navbar";
import Component from "./DashboardNavbar";

export default makeConnectedNavbar(Component);
